import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
  selector: 'app-removal-reason-dialog',
  templateUrl: './removal-reason-dialog.component.html',
  styleUrls: ['./removal-reason-dialog.component.scss']
})
export class RemovalReasonDialogComponent implements OnInit {
  @Input() display: boolean = false;
  @Input() skillName: string = '';
  @Output() onConfirm = new EventEmitter<string>();
  @Output() onCancel = new EventEmitter<void>();

  removalReason: string = '';
  errorMessages: string[] = [];
  mandatoryFields = {
    removalReason: false
  };

  ngOnInit(): void {
    // Reset state when dialog opens
    if (this.display) {
      this.resetDialog();
    }
  }

  ngOnChanges(): void {
    // Reset when display changes to true
    if (this.display && this.removalReason === '') {
      this.resetDialog();
    }
  }

  resetDialog(): void {
    this.removalReason = '';
    this.errorMessages = [];
    this.mandatoryFields.removalReason = false;
  }

  saveReason(): void {
    this.errorMessages = [];
    this.validateControls();

    if (this.errorMessages.length === 0) {
      this.onConfirm.emit(this.removalReason);
      this.resetDialog();
    }
  }

  private validateControls(): void {
    const isWhitespace = (this.removalReason || '').trim().length === 0;
    
    if (
      this.removalReason === '' ||
      this.removalReason === undefined ||
      isWhitespace
    ) {
      this.mandatoryFields.removalReason = true;
      this.errorMessages.push('Removal reason is required.');
    }
  }

  cancel(): void {
    this.resetDialog();
    this.onCancel.emit();
  }
}
